module.exports = __webpack_public_path__ + "img/model_51_zh.8464e982.jpg";